import {noop} from "lodash";
import api from "../../api/api";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";

export const notificationList = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.MessageNotificationList)) return null;
        const url = "/message/notification/list";
        const response = await api.post(url, {...data});

        if (response?.status === 200 && (response?.data?.code === 200 || response?.data?.code === 0)) {
            onSuccess(response.data);
        } else {
            onError(response?.data?.msg, response?.data?.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const notificationRead = (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.MessageNotificationRead)) return null;
        const url = "/message/notification/read";
        const response = await api.post(url, {...data});

        if (response?.status === 200 && (response?.data?.code === 200 || response?.data?.code === 0)) {
            onSuccess(response.data);
        } else {
            onError(response?.data?.msg, response?.data?.code);
        }
    } catch (e) {
        onError(e.message);
    }
};

export const notificationUnreadCount = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.MessageNotificationList)) return null;
        const url = "/message/notification/unread-count";
        const response = await api.get(url);

        if (response?.status === 200 && (response?.data?.code === 200 || response?.data?.code === 0)) {
            onSuccess(response.data);
        } else {
            onError(response?.data?.msg, response?.data?.code);
        }
    } catch (e) {
        onError(e.message);
    }
};
